import { createFileRoute } from "@tanstack/react-router";
import { OG_IMAGE, absolute, hreflangLinks } from "@/lib/site";
import { breadcrumbList } from "@/lib/schema";
import { TopBar } from "@/components/TopBar";
import { Navbar } from "@/components/Navbar";
import { ContactContent } from "@/components/ContactContent";
import { Footer } from "@/components/Footer";

export const Route = createFileRoute("/ar/contact")({
  head: () => ({
    meta: [
      { title: "تواصل مع عراق سيرت | التحضير للأيزو وتسجيل الموردين" },
      {
        name: "description",
        content:
          "ناقش متطلب التحضير للأيزو أو تسجيل الموردين مع عراق سيرت. ابدأ بنشاط شركتك وموقعها ومتطلب المشتري عبر واتساب أو الهاتف أو البريد الإلكتروني.",
      },
      { property: "og:title", content: "تواصل مع عراق سيرت | التحضير للأيزو وتسجيل الموردين" },
      {
        property: "og:description",
        content:
          "ناقش متطلب التحضير للأيزو أو تسجيل الموردين مع عراق سيرت. ابدأ بنشاط شركتك وموقعها ومتطلب المشتري عبر واتساب أو الهاتف أو البريد الإلكتروني.",
      },
      { property: "og:url", content: absolute("/ar/contact") },
      { property: "og:image", content: OG_IMAGE },
      { property: "og:locale", content: "ar_IQ" },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [{ rel: "canonical", href: absolute("/ar/contact") }, ...hreflangLinks("/contact")],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          breadcrumbList([
            { name: "الرئيسية", path: "/ar" },
            { name: "اتصل بنا", path: "/ar/contact" },
          ]),
        ),
      },
    ],
  }),
  component: ContactPageAr,
});

function ContactPageAr() {
  return (
    <div className="min-h-screen bg-background">
      <TopBar />
      <Navbar />
      <main>
        <ContactContent />
      </main>
      <Footer />
    </div>
  );
}
